import { createContext } from 'react';

interface userObjectInterface {
    cognitoUser: any;
    profile: any;
    registrants: any;
    username: any;
    authenticated: boolean;
    userType?: string;
    guestAccess?: {
        active: boolean;
        verified: boolean;
        paymentsRequired: boolean;
        subscriptionRequired: boolean;
        subscriptionActive: boolean;
        subscriptionStatus: string;
        pendingReason: string;
    };
    guestIdentity?: Record<string, unknown>;
    needsOnboarding?: boolean;
}
interface defaultUserInterface {
    userObject: userObjectInterface;
    setUser: Function;
    reloadRegistrantLists: Function;
}

const defaultValue: defaultUserInterface = {
    userObject: {
        cognitoUser: {},
        profile: undefined,
        registrants: {
            list: [],
            activeRegistrantsIndexes: [],
        },
        username: undefined,
        authenticated: false,
    },
    setUser: userObject => {},
    reloadRegistrantLists: () => {},
};

const UserContext = createContext(defaultValue);

export default UserContext;
